import plaintextrequest from '@/utils/plaintextrequest'
import request from '@/utils/request'

// 领券中心
export function couponcenter(data) {
	return plaintextrequest({
		url: '/coupon/NoThresholdCoupon',
		method: 'post',
		data
	})
}
// 领券
export function getcoupon(data) {
	return request({
		url: '/Coupon/getcoupon',
		method: 'post',
		data
	})
}

export function getCouponNew(data) {
	return request({
		url: '/Coupon/getcoupon_xh',
		method: 'post',
		data
	})
}


// 抢购优惠券列表
export function couponFlashLists(data) {
	return request({
		url: '/Couponflash/lists',
		method: 'post',
		data
	})
}

// 抢购优惠券领取
export function getCouponFlash(data) {
	console.log("data", data)
	return request({
		url: '/Couponflash/getcoupon',
		method: 'post',
		data
	})
}

// 删除优惠券（软删除，可在已删除列表找回）
export function disablecoupon(data) {
	console.log("data", data)
	
	return request({
		url: '/Coupon/disablecoupon',
		method: 'post',
		data
	})
}

// 取消删除优惠券（恢复）
export function enablecoupon(data) {
	return request({
		url: '/Coupon/enablecoupon',
		method: 'post',
		data
	})
}
